import {
	SHOP_MERCH_CATEGORIES,
	type ShopMerchCategory,
} from '#lib/websites/shop/constants/categories.js';

interface MerchCategoryRelation {
	ECM_Product_Category_id?: { name?: string | null } | null;
}

export interface ArtistMerchItemWithCategories {
	product?: {
		product_categories?: Array<MerchCategoryRelation | null> | null;
	} | null;
	variations?: Array<{
		related_Merch_Item_id?: {
			product?: {
				product_categories?: Array<MerchCategoryRelation | null> | null;
			} | null;
		} | null;
	} | null> | null;
}

const getRelationNames = (
	relations: Array<MerchCategoryRelation | null> | null | undefined
) =>
	(relations || [])
		.map((relation) => relation?.ECM_Product_Category_id?.name)
		.filter((name): name is string => Boolean(name));

export const getArtistMerchItemCategoryNames = (
	item: ArtistMerchItemWithCategories
) => [
	...getRelationNames(item.product?.product_categories),
	...(item.variations || []).flatMap((variation) =>
		getRelationNames(
			variation?.related_Merch_Item_id?.product?.product_categories
		)
	),
];

export const getArtistMerchCategories = (
	items: ArtistMerchItemWithCategories[] | null | undefined
): ShopMerchCategory[] =>
	SHOP_MERCH_CATEGORIES.filter((category) =>
		(items || []).some((item) =>
			getArtistMerchItemCategoryNames(item).includes(category)
		)
	);

export const filterArtistMerchItems = <T extends ArtistMerchItemWithCategories>(
	items: T[] | null | undefined,
	category: ShopMerchCategory | null
): T[] =>
	category
		? (items || []).filter((item) =>
				getArtistMerchItemCategoryNames(item).includes(category)
			)
		: [...(items || [])];

export const isShopMerchCategory = (
	value: string | null
): value is ShopMerchCategory =>
	SHOP_MERCH_CATEGORIES.some((category) => category === value);
